import { BaseWebStorage } from './BaseWebStorage'

/**
 * Sets current timestamp when called setItem
 * Timestamp represents time when our app last time checked for new updates
 */
class LastCheckUpdatesTimeStorage extends BaseWebStorage<number | null> {
    protected key = 'LAST_CHECK_UPDATES_TIME'

    getItem() {
        const value = this.storage.getItem(this.key)

        return value ? Number(this.storage.getItem(this.key)) : null
    }

    setItem() {
        this.storage.setItem(this.key, Date.now().toString())
    }

    removeItem() {
        return this.storage.removeItem(this.key)
    }
}

export const lastCheckUpdatesTimeStorage = new LastCheckUpdatesTimeStorage(
    'sessionStorage',
)
